
// TODO a lot
// arguments:
// Contract.requiresArgument(value, position, name).toBeDefined().andToBeAnArray()

  /**
   * @class Contract
   * @memberOf farmnet.admin.shop
   * @param $log
   * @param {farmnet.admin.shop.value} value // TODO
   * @constructor
   */
ContractService.$inject = [
  '$log',
  'value'
];

export function ContractService ($log, value) {
    'use strict';

    function ContractError(message) {
      this.name = 'ContractError';
      this.message = message;
    }
    ContractError.prototype = new Error();
    ContractError.prototype.constructor = ContractError;

    // TODO doc
    // see http://msdn.microsoft.com/de-de/library/system.diagnostics.contracts.contract(v=vs.110).aspx

    this.throwErrorOnFailure = true;

    /**
     *
     * @param {boolean} condition
     * @param {string} message
     */
    this.assert = function(condition, message) {
      if (!condition) {
        // TODO
        $log.error('Code Contract assertions failed:', message);
        if (this.throwErrorOnFailure) {
          // TODO
          throw new ContractError(message);
        }
      }
    };

    this.ensures = function(condition, message) {
      // TODO
      this.assert(condition, message);
    };

    this.requires = function(condition, message) {
      // TODO
      this.assert(condition, message);
    };

    /**
     *
     * @param {*} argument
     * @param {number} position
     * @param {string} name
     * @param {string} [message=null]
     */
    this.requiresArgumentToBeDefined = function(
      argument,
      position,
      name,
      message
    ) {
      message = message || '';
      this.assert(
        value(argument).isDefined(),
        'Argument at position {0}, "{1}", must be defined. {2}'.format(
          position,
          name,
          message
        )
      );
    };

    /**
     *
     * @param {*} argument
     * @param {number} position
     * @param {string} name
     * @param {string} [message=null]
     */
    this.requiresArgumentToBeUndefined = function(
      argument,
      position,
      name,
      message
    ) {
      message = message || '';
      this.assert(
        value(argument).isUndefined(),
        'Argument at position {0}, "{1}", must be defined. {2}'.format(
          position,
          name,
          message
        )
      );
    };

    /**
     *
     * @param {*} argument
     * @param {number} position
     * @param {string} name
     * @param {string} [message=null]
     */
    this.requiresArgumentToBeNumber = function(
      argument,
      position,
      name,
      message
    ) {
      message = message || '';
      this.assert(
        value(argument).isNumber(),
        'Argument at position {0}, "{1}", must be a number. {2}'.format(
          position,
          name,
          message
        )
      );
    };

    /**
     *
     * @param {*} argument
     * @param {number} position
     * @param {string} name
     * @param {string} [message=null]
     */
    this.requiresArgumentToBeBoolean = function(
      argument,
      position,
      name,
      message
    ) {
      message = message || '';
      this.assert(
        value(argument).isBoolean(),
        'Argument at position {0}, "{1}", must be a boolean. {2}'.format(
          position,
          name,
          message
        )
      );
    };

    /**
     *
     * @param {*} argument
     * @param {number} position
     * @param {string} name
     * @param {string} [message='']
     */
    this.requiresArgumentToBeString = function(
      argument,
      position,
      name,
      message
    ) {
      message = message || '';
      this.assert(
        value(argument).isString(),
        'Argument at position {0}, "{1}", must be a string. {2}'.format(
          position,
          name,
          message
        )
      );
    };

    this.requiresArgumentToBeObject = function(
      argument,
      position,
      name,
      message
    ) {
      message = message || '';
      this.assert(
        value(argument).isObject(),
        'Argument at position {0}, "{1}", must be an object. {2}'.format(
          position,
          name,
          message
        )
      );
    };

    this.requiresArgumentToBeInstanceOf = function(
      argument,
      position,
      name,
      constructor,
      message
    ) {
      message = message || '';
      this.assert(
        (value(argument).isInstanceOf(constructor),
        'Argument at position {0}, "{1}", must be an instance of {2}. \n{3}'.format(
          position,
          name,
          constructor,
          message
        ))
      );
    };

    this.requiresArgumentToBeObjectLike = function(
      argument,
      position,
      name,
      object,
      message
    ) {
      message = message || '';
      this.assert(
        value(argument).isLike(object),
        'Argument at position {0}, "{1}", must be an object like:\n{2}\n{3}'.format(
          position,
          name,
          angular.toJson(object),
          message
        )
      );
    };

    this.requiresArgumentToBeArray = function(
      argument,
      position,
      name,
      message
    ) {
      message = message || '';
      this.assert(
        value(argument).isArray(),
        'Argument at position {0}, "{1}", must be an array. {2}'.format(
          position,
          name,
          message
        )
      );
    };

    this.requiresObject = function(any, message) {
      message = message || '';
      this.assert(value(any).isObject(), 'Expected an object. ' + message);
    };
}
